import React from 'react';
import PropTypes from 'prop-types';

import tatiAvatar from 'assets/images/tati-avatar-2-square.webp';

import './assistant-avatar.scss';

const AssistantAvatar = ({ typeAvatar }) => (
  <section className={`assistant-avatar ${typeAvatar}`}>
    <div className={`assistant-avatar__imgcontainer ${typeAvatar}`}>
      <img src={tatiAvatar} alt="Tatianas profile pic" />
    </div>
  </section>
);

AssistantAvatar.defaultProps = {
  typeAvatar: 'loading',
};

AssistantAvatar.propTypes = {
  typeAvatar: PropTypes.oneOf(['loading', 'welcome', 'bubble']),
};

export default AssistantAvatar;
